/** Setter of the company primary colour used by authenticated layouts (8.12.2). */
import { createContext, useContext } from 'react';

export const BrandColorSetterContext = createContext<((brandColor: string | null) => void) | null>(null);

export function useBrandColorSetter(): (brandColor: string | null) => void {
  const setter = useContext(BrandColorSetterContext);
  return setter ?? (() => undefined);
}
